import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "inline", "mobile", "isOpen"];
import styled, { css } from 'styled-components';
import { useMeasure } from './useMeasure';
import { LEFT_ALIGNED, RIGHT_ALIGNED } from 'conversations-internal-schema/widget-location/constants/WidgetLocations';
import { useBrowserWindowContext } from './BrowserWindowContext';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const widgetLocationStyles = {
  [RIGHT_ALIGNED]: css(["right:0;align-items:flex-end;"]),
  [LEFT_ALIGNED]: css(["left:0;align-items:flex-start;"])
};
const inlineCss = css(["padding:0;inset:0;"]);
const Wrapper = styled.div.withConfig({
  displayName: "WidgetWrapper__Wrapper",
  componentId: "sc-1bv4zy4-0"
})(["position:absolute;bottom:0;display:flex;padding:", ";gap:12px;flex-direction:column;justify-content:flex-end;", ";"], ({
  mobile
}) => mobile ? '8px' : '16px', ({
  widgetLocation,
  inline
}) => inline ? inlineCss : widgetLocationStyles[widgetLocation]);
export default function WidgetWrapper(_ref) {
  let {
      children,
      inline,
      mobile,
      isOpen
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    browserWindowHeight,
    browserWindowWidth
  } = useBrowserWindowContext();
  const ref = useMeasure();
  const [style, setStyle] = useState(() => {
    return mobile && isOpen ? {
      height: browserWindowHeight,
      width: browserWindowWidth
    } : {};
  });
  useEffect(() => {
    if (mobile) {
      const timeoutId = setTimeout(() => {
        setStyle(isOpen ? {
          height: browserWindowHeight,
          width: browserWindowWidth
        } : {});
      }, isOpen ? 0 : 500);
      return () => clearTimeout(timeoutId);
    }
  }, [isOpen, mobile, browserWindowHeight, browserWindowWidth]);
  return /*#__PURE__*/_jsx(Wrapper, Object.assign({
    style: style,
    ref: ref,
    inline: inline
  }, props, {
    mobile: mobile,
    children: children
  }));
}
WidgetWrapper.displayName = 'WidgetWrapper';